/* src/app/components/summarize/summarize-content/summarize-content.component.scss */
.summarize-composer {
  --primary: #253b80;
  --primary-hover: #1d2f68;
  --primary-soft: #f0f3ff;
  --text: #101828;
  --text-secondary: #667085;
  --text-muted: #98a2b3;
  --border: #e4e7ec;
  --border-hover: #cfd5e2;
  --border-focus: #7585c7;
  --surface: #ffffff;
  --surface-soft: #f8f9fc;
  --surface-muted: #f2f4f7;
  width: 100%;
  overflow: hidden;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 18px;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.03), 0 8px 24px rgba(16, 24, 40, 0.045);
}
.content-input-section {
  width: 100%;
}
.input-header {
  min-height: 74px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 18px;
  background:
    linear-gradient(
      180deg,
      #ffffff 0%,
      #fafbff 100%);
  border-bottom: 1px solid var(--border);
}
.input-title {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}
.input-icon {
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    linear-gradient(
      135deg,
      #f1f4ff 0%,
      #e9edff 100%);
  border: 1px solid #dfe5ff;
  border-radius: 11px;
  color: var(--primary);
  font-size: 17px;
  box-shadow: 0 3px 8px rgba(37, 59, 128, 0.06);
}
.input-title-content {
  min-width: 0;
}
.input-title-content h4 {
  margin: 0;
  color: var(--text);
  font-size: 16px;
  font-weight: 700;
  line-height: 1.35;
  letter-spacing: -0.01em;
}
.input-title-content p {
  margin: 4px 0 0;
  color: var(--text-secondary);
  font-size: 11px;
  font-weight: 400;
  line-height: 1.45;
}
.ai-badge {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 10px;
  background: #f5f3ff;
  border: 1px solid #e1dcff;
  border-radius: 999px;
  color: #5145cd;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
}
.ai-badge i {
  font-size: 10px;
}
#autocomplete-wrapper {
  width: 100%;
  padding: 18px;
}
.textarea-wrapper {
  width: 100%;
  overflow: hidden;
  background: var(--surface);
  border: 1px solid #d0d5dd;
  border-radius: 13px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.textarea-wrapper:hover {
  border-color: var(--border-hover);
}
.textarea-wrapper:focus-within {
  border-color: var(--border-focus);
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.08);
}
.textarea-wrapper.has-error {
  border-color: #f04438;
  box-shadow: 0 0 0 3px rgba(240, 68, 56, 0.08);
}
.textarea-wrapper.has-error:focus-within {
  border-color: #f04438;
}
.textarea-label-row {
  min-height: 42px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 9px 13px;
  background: #fcfcfd;
  border-bottom: 1px solid #eaecf0;
}
.textarea-label-row label {
  margin: 0;
  color: #344054;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.4;
}
.required-label {
  display: inline-flex;
  align-items: center;
  padding: 4px 7px;
  background: #fff7f7;
  border: 1px solid #fecaca;
  border-radius: 999px;
  color: #b42318;
  font-size: 9px;
  font-weight: 700;
  line-height: 1;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.form-textarea {
  width: 100%;
  min-height: 200px;
  display: block;
  padding: 15px;
  resize: vertical;
  border: 0;
  outline: none;
  background: #ffffff;
  color: var(--text);
  font-family: inherit;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.7;
}
.form-textarea::placeholder {
  color: #98a2b3;
  opacity: 1;
}
.form-textarea:focus {
  outline: none;
}
.form-textarea::selection {
  background: rgba(37, 59, 128, 0.14);
}
.textarea-bottom {
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 12px;
  background: var(--surface-soft);
  border-top: 1px solid #eaecf0;
}
.textarea-hint {
  min-width: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--text-secondary);
  font-size: 10px;
  font-weight: 500;
  line-height: 1.4;
}
.textarea-hint i {
  flex: 0 0 auto;
  color: #98a2b3;
  font-size: 10px;
}
.textarea-hint span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.character-count {
  flex: 0 0 auto;
  color: var(--text-muted);
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
}
.error-message {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-top: 8px;
  padding: 0 2px;
  color: #b42318;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.5;
}
.error-message i {
  flex: 0 0 auto;
  font-size: 11px;
}
.composer-footer {
  width: 100%;
  min-height: 76px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 12px 14px;
  background: #f8f9fc;
  border-top: 1px solid var(--border);
}
.upload-area {
  min-width: 0;
  flex: 1;
}
.upload-button {
  width: auto;
  max-width: 100%;
  min-height: 48px;
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 5px 10px 5px 6px;
  background: #ffffff;
  border: 1px solid #dfe3ea;
  border-radius: 11px;
  color: #344054;
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    background-color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.2s ease;
}
.upload-button:hover {
  background: #fbfcff;
  border-color: #c7cdd9;
  box-shadow: 0 4px 12px rgba(16, 24, 40, 0.07);
  transform: translateY(-1px);
}
.upload-button:hover .button-icon {
  background: #eef1ff;
  color: var(--primary);
}
.upload-button:hover .upload-arrow {
  color: var(--primary);
  transform: translateX(2px);
}
.upload-button:active {
  transform: translateY(0);
}
.upload-button:focus-visible {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.1);
}
.button-icon {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f2f4f7;
  border-radius: 9px;
  color: #475467;
  font-size: 15px;
  transition: background-color 0.2s ease, color 0.2s ease;
}
.button-content {
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}
.button-content strong {
  overflow: hidden;
  color: #344054;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.button-content small {
  color: #98a2b3;
  font-size: 9px;
  font-weight: 500;
  line-height: 1.3;
}
.upload-arrow {
  margin-left: 2px;
  color: #98a2b3;
  font-size: 9px;
  transition: color 0.2s ease, transform 0.2s ease;
}
.action-buttons {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 8px;
}
.clear-button,
.summary-button {
  min-height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 13px;
  border-radius: 10px;
  font-family: inherit;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.2s ease;
}
.clear-button:focus-visible,
.summary-button:focus-visible {
  outline: none;
}
.clear-button:active:not(:disabled),
.summary-button:active:not(:disabled) {
  transform: translateY(1px);
}
.clear-button:disabled,
.summary-button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}
.clear-button {
  min-width: 72px;
  background: #ffffff;
  border: 1px solid #d0d5dd;
  color: #475467;
}
.clear-button:hover:not(:disabled) {
  background: #f9fafb;
  border-color: #98a2b3;
  color: #344054;
}
.clear-button:focus-visible {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.09);
}
.clear-button i {
  font-size: 10px;
}
.summary-button {
  min-width: 168px;
  background: var(--primary);
  border: 1px solid var(--primary);
  color: #ffffff;
  box-shadow: 0 4px 10px rgba(37, 59, 128, 0.18);
}
.summary-button:hover:not(:disabled) {
  background: var(--primary-hover);
  border-color: var(--primary-hover);
  box-shadow: 0 6px 15px rgba(37, 59, 128, 0.24);
  transform: translateY(-1px);
}
.summary-button:hover:not(:disabled) .button-arrow {
  transform: translateX(3px);
}
.summary-button:focus-visible {
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.14), 0 4px 10px rgba(37, 59, 128, 0.18);
}
.summary-button:disabled {
  background: #c7cbd8;
  border-color: #c7cbd8;
  box-shadow: none;
}
.summary-button > i:first-child {
  font-size: 12px;
}
.button-arrow {
  margin-left: 1px;
  font-size: 9px;
  transition: transform 0.2s ease;
}
:host ::ng-deep .sidebar,
:host ::ng-deep .sidebar-wrapper {
  position: relative;
  z-index: 1002;
}
.spinner-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(15, 23, 42, 0.42);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  pointer-events: auto;
  overscroll-behavior: contain;
}
.loading-card {
  position: relative;
  z-index: 1;
  width: min(100%, 400px);
  display: flex;
  align-items: center;
  gap: 13px;
  padding: 18px 20px;
  background: #ffffff;
  border: 1px solid #eaecf0;
  border-radius: 15px;
  box-shadow: 0 20px 45px rgba(16, 24, 40, 0.2);
  animation: summaryLoadingIn 0.22s ease-out;
}
.loading-card {
  width: min(100%, 400px);
  display: flex;
  align-items: center;
  gap: 13px;
  padding: 16px 18px;
  background: #ffffff;
  border: 1px solid #eaecf0;
  border-radius: 15px;
  box-shadow: 0 20px 45px rgba(16, 24, 40, 0.16), 0 4px 12px rgba(16, 24, 40, 0.08);
  animation: summaryLoadingIn 0.22s ease-out;
}
.loading-icon {
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    linear-gradient(
      135deg,
      #f1f4ff 0%,
      #e9edff 100%);
  border: 1px solid #dfe5ff;
  border-radius: 11px;
  color: var(--primary);
  font-size: 16px;
}
.loading-content {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.loading-content strong {
  color: var(--text);
  font-size: 13px;
  font-weight: 700;
  line-height: 1.4;
}
.loading-content span {
  color: var(--text-secondary);
  font-size: 10px;
  font-weight: 400;
  line-height: 1.4;
}
@keyframes summaryLoadingIn {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 768px) {
  .input-header {
    padding: 14px 16px;
  }
  #autocomplete-wrapper {
    padding: 16px;
  }
  .composer-footer {
    align-items: stretch;
    flex-direction: column;
    gap: 12px;
    padding: 13px 14px;
  }
  .upload-area {
    width: 100%;
  }
  .upload-button {
    width: 100%;
  }
  .action-buttons {
    width: 100%;
  }
  .clear-button,
  .summary-button {
    flex: 1;
  }
  .summary-button {
    min-width: 0;
  }
}
@media (max-width: 576px) {
  .summarize-composer {
    border-radius: 15px;
  }
  .input-header {
    align-items: flex-start;
    gap: 10px;
    padding: 14px;
  }
  .input-icon {
    width: 38px;
    height: 38px;
    flex-basis: 38px;
    border-radius: 10px;
    font-size: 15px;
  }
  .input-title-content h4 {
    font-size: 14px;
  }
  .input-title-content p {
    margin-top: 3px;
    font-size: 10px;
  }
  .ai-badge {
    padding: 6px 8px;
    font-size: 9px;
  }
  #autocomplete-wrapper {
    padding: 14px;
  }
  .textarea-label-row {
    min-height: 40px;
    padding: 8px 11px;
  }
  .form-textarea {
    min-height: 180px;
    padding: 13px;
    font-size: 13px;
    line-height: 1.65;
  }
  .textarea-bottom {
    align-items: flex-start;
    flex-direction: column;
    gap: 5px;
    padding: 8px 11px;
  }
  .textarea-hint {
    width: 100%;
  }
  .textarea-hint span {
    white-space: normal;
  }
  .character-count {
    align-self: flex-end;
  }
  .composer-footer {
    padding: 12px;
  }
  .action-buttons {
    gap: 7px;
  }
  .clear-button,
  .summary-button {
    min-height: 44px;
  }
  .loading-card {
    gap: 11px;
    padding: 14px;
  }
}
@media (max-width: 400px) {
  .input-header {
    padding: 13px;
  }
  .ai-badge {
    display: none;
  }
  #autocomplete-wrapper {
    padding: 12px;
  }
  .composer-footer {
    padding: 11px;
  }
  .action-buttons {
    flex-direction: column;
  }
  .clear-button,
  .summary-button {
    width: 100%;
    flex: none;
  }
  .upload-arrow {
    display: none;
  }
  .loading-card {
    width: 100%;
  }
}
@media (hover: none) {
  .upload-button:hover {
    background: #ffffff;
    border-color: #dfe3ea;
    box-shadow: none;
    transform: none;
  }
  .upload-button:hover .button-icon {
    background: #f2f4f7;
    color: #475467;
  }
  .upload-button:hover .upload-arrow {
    color: #98a2b3;
    transform: none;
  }
  .summary-button:hover:not(:disabled) {
    transform: none;
    box-shadow: 0 4px 10px rgba(37, 59, 128, 0.18);
  }
  .summary-button:hover:not(:disabled) .button-arrow {
    transform: none;
  }
}
@media (prefers-reduced-motion: reduce) {
  .textarea-wrapper,
  .upload-button,
  .button-icon,
  .upload-arrow,
  .clear-button,
  .summary-button,
  .button-arrow,
  .loading-card {
    transition: none;
    animation: none;
  }
}
/*# sourceMappingURL=summarize-content.component.css.map */
